// ROUTES
import { ROUTE_SGU_ADMIN_FUNCIONALIDADE } from '../../routes/paths';

// ADMINISTRAR
export const ROUTE_SGU_ADMIN_FUNCIONALIDADE_CADASTRAR = `${ROUTE_SGU_ADMIN_FUNCIONALIDADE}/cadastro`;
export const ROUTE_SGU_ADMIN_FUNCIONALIDADE_EDITAR = `${ROUTE_SGU_ADMIN_FUNCIONALIDADE}/editar`;
